import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Button } from "@mantine/core";
import { makeStyles } from "@material-ui/styles";
import { AppContext, OPEN_BOOKINGSMODAL } from "../Context";

const useStyles = makeStyles({
  button: {
    "@media(max-width: 667px)": {
      border: "none",
      "&:hover": {
        border: "none",
      },
      "&:active": {
        border: "none",
      },
      "&:visited": {
        border: "none",
      },
    },
  },
});

const BookButton = (props) => {
  const { book, bookingData, loading, manages } = props;
  const classes = useStyles();
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { language, auth } = useSelector((state) => ({
    auth: state.oidc.user !== null && !state.oidc.user.expired,
    language: state.language,
  }));

  const canBook = bookingData && bookingData.canReserve.reserve;
  const canEnqueue = bookingData && bookingData.canReserve.enqueue;
  const isOccasion = bookingData.__typename === "occasion";
  const handleBook = () => {
    if (manages.length < 2 && isOccasion) return book(bookingData.id);
    return dispatch({ type: OPEN_BOOKINGSMODAL, payload: bookingData });
  };

  let text = "";
  if (language) {
    text = canBook
      ? language.book
      : canEnqueue
      ? language.enqueue
      : language.reason[bookingData.canReserve.reason] ||
        bookingData.canReserve.reason;
  }

  if (!auth) return <div />;

  if (canBook || canEnqueue)
    return (
      <Button
        loading={loading}
        color="violet.8"
        size="sm"
        title={`${language.book}`}
        onClick={() => handleBook()}
        classes={{
          outlined: classes.button,
        }}
      >{`${text}`}</Button>
    );

  return <div />;
};

export default BookButton;
